import { registerBlockType } from "@wordpress/blocks";

import edit from "./edit";
import save from "./save";
import deprecated from "./deprecated";
import transforms from "./transforms";

// @ts-ignore
registerBlockType("justwatch/partners", {
  title: "JustWatch",
  description: "Connect your audience to the best streaming services worldwide.",
  icon: 'controls-play',
  attributes: {
    id: {
      type: "string",
    },
    idType: {
      type: "string",
    },
    objectType: {
      type: "string",
    },
    seasonNumber: {
      type: "number",
    },
    episodeNumber: {
      type: "number",
    },
    meta: {
      type: "object",
    },
  },
  edit,
  save,
  deprecated,
  transforms,
});
